<template>
  <div class="tool-container">
    <div
      class="text-input-tool"
      @click.stop.prevent=""
    >
      <div class="tool-btn-group">
        <v-menu
          class="mt-2 -mx-2"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="isOpenEmojiPicker ? toggleEmojiPicker : null"
              icon
              max-width="32"
              max-height="32"
              class="tool-btn"
              v-bind="attrs"
              v-on="on"
              color="primary-001"
            >
              <v-img
                max-width="24"
                src="@/assets/images/general/icon_variable.svg"
              />
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="addVariable(item.name)"
              v-for="(item, index) in variables"
              :key="index"
            >
              <v-list-item-title
                class="text-body-2 neutral-041--text"
              >
                {{ item.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-show="showEmoji"
          @click.stop="toggleEmojiPicker"
          icon
          max-width="32"
          max-height="32"
          class="tool-btn"
          color="primary-001"
        >
          <v-img
            max-width="24"
            src="@/assets/images/general/icon_emoji.svg"
          />
        </v-btn>
      </div>
      <Picker
        v-show="isOpenEmojiPicker"
        :data="emojiIndex"
        @select="addEmoji"
        :show-preview="false"
        class="emoji-picker"
        id="emoji-picker"
      />
    </div>
  </div>
</template>

<script>
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast';
import data from 'emoji-mart-vue-fast/data/all.json';
import 'emoji-mart-vue-fast/css/emoji-mart.css';

const emojiIndex = new EmojiIndex(data);
export default {
  name: 'TextareaToolbox',
  inheritAttrs: false,
  components: {
    Picker
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    variables: {
      type: Array,
      default: () => null
    },
    showEmoji: {
      type: Boolean,
      default: true
    }
  },
  computed: {
  },
  data() {
    return {
      isOpenEmojiPicker: false,
      emojiIndex
    };
  },
  methods: {
    toggleEmojiPicker() {
      this.isOpenEmojiPicker = !this.isOpenEmojiPicker;
    },
    addEmoji(emoji) {
      const emojiIcon = emoji.native;
      this.$emit('add-emoji', emojiIcon);
    },
    hideEmojiPicker(e) {
      if (this.isOpenEmojiPicker) {
        this.isOpenEmojiPicker = false;
        this.$emit('focus-textarea');
      }
    },
    addVariable(variable) {
      this.$emit('add-variable', variable);
    }
  },
  mounted() {
    document.body.addEventListener('click', this.hideEmojiPicker);
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.hideEmojiPicker);
  }
};
</script>

<style lang="scss" scoped>
.tool-container {
  width: 100%;
}
.text-input-tool {
  display: inline-block;
  .tool-btn-group {
    display: flex;
    background: $neutral-047;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 4px;
  }
  .emoji-picker {
    position: absolute;
    top: 35px;
    left: 0px;
    z-index: 10;
  }
}

.v-list-item {
  cursor: pointer;
}

.v-menu__content {
  margin-top: 8px;
  margin-left: -4px;
}

::v-deep.tool-btn {
  border-radius: 4px;
  &:not(:last-child) {
    margin-right: 2px;
  }

}

</style>
